export default __webpack_public_path__ + "static/media/portfolio-123.c8dbde74.jpg";